import React from "react"
import classnames from "classnames"
import { SIZE_UNITS } from "../../../services/utils/formatArtworkSize"
import styles from "./UnitSwitch.module.scss"

const UnitSwitch = ({ value, onChange }) => (
  <span className={styles.switch} role="group" aria-label="Size unit">
    {Object.values(SIZE_UNITS).map((unit) => (
      <button
        key={unit}
        type="button"
        aria-pressed={value === unit}
        className={classnames(styles.option, {
          [styles.active]: value === unit,
        })}
        onClick={() => onChange(unit)}>
        {unit}
      </button>
    ))}
  </span>
)

export default UnitSwitch
